import { Reducer } from 'redux'
import {
  FreeTierInfo,
  ProductsListingActionTypes,
  ProductsListingState,
  Product,
} from './types'
import {
  DEFAULT_PRODUCTS_V2_PAGE_SIZE,
  nextProductsV2State,
} from './helper/productsV2Pagination'

export * from './types'

export const initialProductsV2State = {
  rows: [],
  pageNumber: 1,
  pageSize: DEFAULT_PRODUCTS_V2_PAGE_SIZE,
  totalCount: 0,
  hasMore: false,
}

export const initialState: ProductsListingState = {
  products: {
    rows: [],
  },
  productsV2: initialProductsV2State,
  productDetail: undefined,
}

type actionType =
  | {
      type: ProductsListingActionTypes.SET_PRODUCTS_V2
      payload: ProductsListingState
    }
  | {
      type: ProductsListingActionTypes.SET_PRODUCTS
      payload: ProductsListingState
    }
  | {
      type: ProductsListingActionTypes.CLEAR_PRODUCTS
    }
  | {
      type: ProductsListingActionTypes.UPDATE_CLOUD_FREE_TRIAL_OFFER_ID
      payload: { productId: string; cloudFreeTrialOfferId: string }
    }
  | {
      type: ProductsListingActionTypes.SET_SELECTED_PRODUCT
      payload: string
    }
  | {
      type: ProductsListingActionTypes.SET_FREE_TIER_DATA
      payload: FreeTierInfo
    }
  | {
      type: ProductsListingActionTypes.SET_PRODUCTS_WITH_LISTING_DATA
      payload: ProductsListingState
    }
  | {
      type: ProductsListingActionTypes.SET_PRODUCT_DETAIL
      payload: Product
    }
  | {
      type: ProductsListingActionTypes.CLEAR_PRODUCT_DETAIL
    }
export const reducer: Reducer<ProductsListingState, actionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ProductsListingActionTypes.SET_PRODUCTS: {
      return {
        ...state,
        products: action.payload.products,
      }
    }
    case ProductsListingActionTypes.SET_PRODUCTS_V2: {
      return {
        ...state,
        productsV2: nextProductsV2State(
          state.productsV2,
          action.payload.products
        ),
      }
    }
    case ProductsListingActionTypes.SET_PRODUCTS_WITH_LISTING_DATA: {
      return {
        ...state,
        productWithListingData: action.payload.products,
      }
    }
    case ProductsListingActionTypes.CLEAR_PRODUCTS: {
      return {
        ...state,
        products: {
          rows: [],
        },
        productsV2: initialProductsV2State,
      }
    }
    case ProductsListingActionTypes.UPDATE_CLOUD_FREE_TRIAL_OFFER_ID: {
      const { productId, cloudFreeTrialOfferId } = action.payload
      const rows = [
        ...state.products.rows.map(product => {
          if (product.productId === productId) {
            const freeTrial = {
              ...product.freeTrial,
              cloudFreeTrialOfferId,
            }
            return {
              ...product,
              freeTrial,
            }
          } else {
            return product
          }
        }),
      ]
      return {
        ...state,
        products: {
          rows,
        },
      }
    }
    case ProductsListingActionTypes.SET_SELECTED_PRODUCT: {
      return {
        ...state,
        selectedProduct: action.payload,
      }
    }
    case ProductsListingActionTypes.SET_FREE_TIER_DATA: {
      return {
        ...state,
        ...(action.payload?.additionalAllowedProducts !== undefined &&
          action.payload?.additionalAllowedProducts !== null && {
            freeTierInfo: action.payload,
          }),
      }
    }
    case ProductsListingActionTypes.SET_PRODUCT_DETAIL: {
      return {
        ...state,
        productDetail: action.payload,
      }
    }
    case ProductsListingActionTypes.CLEAR_PRODUCT_DETAIL: {
      return {
        ...state,
        productDetail: undefined,
      }
    }
    default: {
      return state
    }
  }
}
